import React from 'react';
import CodeSparkThemedTypography from '../../../../../components/elements/CodeSparkThemedTypography';
import {
  ColumnCenter,
  SectionPaddingVertical,
  SectionWidth,
} from '../../../../../components/global/Layout';
import CtaButtonContainer from '../../../../../components/elements/CtaButton/CtaButtonContainer';
import CtaButton from '../../../../../components/elements/CtaButton';
import { usePlanSelector } from '../hooks';
import SubscriptionPlan from '../V3/SubscriptionPlan';
import { SelectedPlanLegal } from '../V3';
import PlanComparison from './PlanComparison';
import v3Styles from '../V3/PlanSelectorV3.module.css';
import styles from './PlanSelectorV4.module.css';

export default function V4({
  title,
  valueProps,
  planOptionsData,
  selectedOffer,
  onCtaClick,
  ctaLabel,
}) {
  const { handleSelectPlan, handleCtaNavigate } = usePlanSelector({
    onCtaClick,
    navigateOnSelect: false,
  });

  return (
    <SectionWidth>
      <SectionPaddingVertical>
        <ColumnCenter>
          <CodeSparkThemedTypography
            variant="h2"
            align="center"
            className={v3Styles.planSelectorTitle}
          >
            {title}
          </CodeSparkThemedTypography>

          <div
            className={`${v3Styles.planSelectorOptionsContainer} ${styles.planSelectorOptionsContainer}`}
          >
            {planOptionsData.map(planData => {
              const {
                plan: { planId },
              } = planData;

              return (
                <SubscriptionPlan
                  key={planId}
                  selected={selectedOffer && selectedOffer.planId === planId}
                  onClick={e => handleSelectPlan(e, planId)}
                  {...planData}
                />
              );
            })}
          </div>

          <PlanComparison planOptionsData={planOptionsData} valueProps={valueProps} />

          <CtaButtonContainer className={styles.ctaButtonContainer} fullWidthMobile>
            <CtaButton onClick={handleCtaNavigate} type="primary2" fullWidthMobile>
              {ctaLabel}
            </CtaButton>
          </CtaButtonContainer>

          {selectedOffer && <SelectedPlanLegal selectedOffer={selectedOffer} />}
        </ColumnCenter>
      </SectionPaddingVertical>
    </SectionWidth>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/V4/index.js